// @ts-ignore
import bg from "@src/app/assets/email/bg.png"
import blue_bg from "@src/app/assets/email/blue-blue.png"
import logo from "@src/app/assets/email/logo.svg"

export const EmailPictures = () => {
  return (
    <>
      <img alt="logo" src={logo} />
      <img alt="bg" src={bg ?? blue_bg} />
    </>
  )
}
